import {Source, useMap, Layer} from 'react-map-gl';
import {isFillPaint, isSymbolPaint, LayerProps} from './types';
import {useState, useEffect} from 'react';

export default function Points(props: LayerProps) {
    const {data, id, paint, layout} = props;
    const color = isFillPaint(paint) ? paint?.['fill-color'] : undefined;

    const {current: map} = useMap();
    const [, setZoom] = useState(map ? map.getZoom() : 1);

    useEffect(() => {
        if (map) {
            const handleZoom = () => {
                setZoom(map.getZoom());
            };

            map.on('zoom', handleZoom);

            return () => {
                map.off('zoom', handleZoom);
            };
        }
    }, [map]);

    const iconSize = 0.375;
    return (
        <Source id={String(id)} key={id} type='geojson' data={data}>
            <Layer
                id={String(id)}
                type='symbol'
                layout={{'icon-image': 'map-pin', 'icon-size': iconSize, 'icon-allow-overlap': true, 'icon-ignore-placement': true, ...layout}}
                paint={isSymbolPaint(paint) ? paint : {'icon-color': color}}
            />
        </Source>
    );
}
